import { LookbookHeader } from '@app/components/header/LookboookHeader';
import { LookbookContextProvider } from '@app/components/lookbook/context/LookbookContext';
import { LookbookWishlistContextProvider } from '@app/components/lookbook/context/LookbookWishlistContext';
import { LookbookTopBar } from '@app/components/lookbook/LookbookTopBar';
import { useAmplitude } from '@app/utils/hooks';
import { useUrlLookbookProductId } from '@app/utils/hooks/useUrlLookbookProductId';
import { useUrlLookbookVariantId } from '@app/utils/hooks/useUrlLookbookVariantId';
import { isDefined } from '@app/utils/is';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { LookbookCmsPageContent } from './LookbookCmsPageContent';

export const LookbookCmsPage = () => {
  const { lookbookId, pageSlug, wishlistId } = useParams<{ lookbookId: string; pageSlug: string; wishlistId: string | undefined }>();
  const productId = useUrlLookbookProductId();
  const variantId = useUrlLookbookVariantId();
  const { trackEvent } = useAmplitude();

  useEffect(() => {
    trackEvent({ name: 'lookbookCmsPage.page.opened' });
  }, [pageSlug, trackEvent]);

  if (!isDefined(lookbookId) || !isDefined(pageSlug)) {
    return null;
  }

  return (
    <LookbookContextProvider key={lookbookId} lookbookId={lookbookId} locationContext="cms">
      <LookbookWishlistContextProvider wishlistId={wishlistId}>
        <LookbookHeader lookbookId={lookbookId} />
        <LookbookTopBar lookbookId={lookbookId} isCmsPage />
        <LookbookCmsPageContent lookbookId={lookbookId} pageSlug={pageSlug} variantId={variantId} productId={productId} />
      </LookbookWishlistContextProvider>
    </LookbookContextProvider>
  );
};
